/* eslint-disable max-len */
import { chakra } from '@chakra-ui/system';
import { PipeIcon } from '../icons';
export var DateContainer = chakra('div', {
  baseStyle: {
    h: 8,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center'
  },
  label: 'DateContainer'
});
export var CaretAddon = chakra('div', {
  baseStyle: {
    padding: 3,
    width: '50%'
  },
  label: 'CaretAddon'
});
export var TimeContainer = chakra('section', {
  baseStyle: {
    display: 'grid',
    gridTemplateColumns: '80px',
    gridTemplateRows: 'repeat(12, 32px)',
    overflow: 'scroll',
    gridGap: 2,
    height: {
      base: '100%',
      md: '376px'
    },
    width: {
      base: '100%',
      md: '168px'
    },
    maxHeight: {
      base: '300px',
      md: '376px'
    },
    margin: 'auto',
    justifyContent: 'center'
  },
  label: 'TimeContainer'
});
var calendarTitle = {
  fontSize: 'sm',
  color: 'gray.800,'
};
export var CalendarInfo = chakra('div', {
  baseStyle: {
    position: 'relative',
    height: '100%',
    _before: {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      pointerEvents: 'none',
      width: '90%',
      height: '3em'
    },
    _after: {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      bottom: 0,
      left: 0,
      pointerEvents: 'none',
      width: '90%',
      height: '5em'
    }
  },
  label: 'CalendarInfo'
});
export var TimeButton = chakra('button', {
  baseStyle: {
    color: 'black',
    width: '96px',
    height: '30px',
    borderRadius: '5px'
  },
  label: 'TimeButton'
});
export var DividerIcon = chakra(PipeIcon, {
  baseStyle: {
    height: '48px',
    width: '100%',
    color: 'gray.400'
  },
  label: 'DividerContainer'
});
var inlineNavigation = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
};
export var baseStyle = {
  calendarTitle,
  inlineNavigation
};
//# sourceMappingURL=styles.js.map